import { render, staticRenderFns } from "./purchase-plan-desc.vue?vue&type=template&id=4a5c8aad&scoped=true&"
import script from "./purchase-plan-desc.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-desc.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-desc.vue?vue&type=style&index=0&id=4a5c8aad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c8aad",
  null
  
)

export default component.exports